import { api } from "./api";

export const getTestSeriesList = async (addUrl = "") => {
  let url = `/test/series/list${addUrl}`;
  return await api.get(url);
};

export const testSeriesCreate = async (data) => {
  return await api.post(`test/series/add`, data);
};

export const testSeriesUpdate = async (data) => {
  return await api.post(`test/series/update`, data);
};

export const testSeriesDelete = async (id) => {
  return await api.get(`test/series/delete?id=${id}`);
};

export const testList = async (addUrl = "") => {
  let url = `/test/list?${addUrl}`;
  return await api.get(url);
};
export const testAdd = async (data) => {
  return await api.post(`test/add`, data);
};

export const testUpdate = async (data) => {
  return await api.post("test/update", data);
};

export const getTestDetails = async (id) => {
  return await api.get(`test/details/${id}`);
};

export const testDelete = async (id) => {
  return await api.get(`test/delete?id=${id}`);
};

export const obtendMarks = async (data) => {
  return await api.post(`/test/marks/post`, data);
};
export const marksExcelUpload = async (data) => {
  return await api.post(`/test/marks/excel/upload`, data);
};

export const AbsentPresnt = async (data) => {
  return await api.post(`test/attendance`, data);
};

export const testLock = async (id) => {
  return await api.post(`test/locked?id=${id}`);
};
export const testMessage = async (id) => {
  return await api.get(`/student/test/report/send?id=${id}`);
};

export const testUnLock = async (id) => {
  return await api.post(`test/unlocked?id=${id}`);
};

export const fetchCard = async (addUrl = "") => {
  let url = `/test/admin/card/details?${addUrl}`;
  return await api.get(url);
};
// export const fetchCard = async (id, addUrl = '') => {
//     let url = `/test/details/${id}?${addUrl}`
//     return await api.get(url)
// }
export const fetchAnnualData = async (addUrl = "") => {
  let url = `/test/details/student/tests?${addUrl}`;
  return await api.get(url);
};
export const fetchAnnualExcel = async (addUrl = "") => {
  let url = `/test/student/details/test?${addUrl}`;
  return await api.get(url);
};

export const getTestSyllabus = async (testId) => {
  return await api.get(`/tests/${testId}/syllabus`);
};

export const saveTestSyllabus = async (testId, data) => {
  return await api.post(`/tests/${testId}/syllabus`, data);
};

export const deleteTestSyllabus = async (testId, subjectId) => {
  return await api.post(`/tests/${testId}/syllabus/${subjectId}/delete`);
};

export const notifyAllTestSyllabus = async (testId) => {
  return await api.post(`/tests/${testId}/syllabus/notify-all`);
};
